import { defineRows, FieldTemplate, TemplateRow } from '../../../app/components/fields-template/field-template';
import type { entityTypes } from '../entitytypes';
import { BASE_ROWS } from './base';

type InventorizeET = (typeof entityTypes)['inventorize'];

export class InventorizeTemplate implements FieldTemplate {
    rows: TemplateRow[] = defineRows<InventorizeET>([
        ...BASE_ROWS,
        {
            type: 'row',
            children: [{ type: 'field', fieldKey: 'behoefteUren', fieldGroup: 'pheData', classes: 'col-24 col-md-8' }],
        },
    ]);
}
